import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  metaTitle: "IT-Radio: сервис для прослушивания подкастов и музыки",
  metaDescription:
    "Для всех, кто живет IT и технологиями. Честные подкасты с экспертами, новости без воды, практические советы и музыка, которая попадает в ритм твоей работы.",
};

export const metaTagsSlice = createSlice({
  name: "metaTagsSlice",
  initialState,
  reducers: {
    setMetaTags: (state, action) => {
      const newState = { ...state };

      for (const key in action.payload) {
        if (action.payload[key]) {
          newState[key] = action.payload[key];
        }
      }

      return newState;
    },
    setDefaultMetaTags: () => {
      return initialState;
    },
  },
});

export const { setMetaTags, setDefaultMetaTags } = metaTagsSlice.actions;

export default metaTagsSlice.reducer;
